(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvWorkflowResponse', drvWorkflowResponse);

    drvWorkflowResponse.$inject = ['$compile', '$injector'];
    
    function drvWorkflowResponse($compile, $injector) {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                instanceId: '=',
                step: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.$watch('step.StepType', function (stepType) {
                element.empty();

                if (angular.isDefined(stepType) && stepType !== null) {
                    var directiveName = 'drvWorkflowResponse' + stepType + 'Directive';
                    var html;

                    if ($injector.has(directiveName)) {
                        var directiveHtml = convertDirectiveNameToHtml(directiveName);
                        html = '<' + directiveHtml + '></' + directiveHtml + '>';
                    } else {
                        html = '<p>Could not find directive : ' + directiveName + '</p>';
                    }

                    var el = $compile(html)(scope);
                    element.append(el);
                }
            });
        }

        /**
         * Convert a directive name, e.g. 'drvFooBar' to the HTML name, e.g. 'drv-foo-bar'.
         */
        function convertDirectiveNameToHtml(directiveName) {
            var regex = /[A-Z]/g;

            return directiveName.replace(regex, function(match, index, original) {
                return '-' + match.toLowerCase();
            }).replace('-directive', '');
        }
    }
})();